import axios from 'axios'
import qs from 'qs';
var service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 50000
})
// 测试环境 　　　 https://test.tk.lanjiyin.com.cn
// 生产环境 　　　 https://tk.lanjiyin.com.cn
let api = ''


if (location.hostname == 'm.lanjiyin.com.cn') {
    api = 'https://tk.lanjiyin.com.cn'
} else if (location.hostname == 'mobile.lanjiyin.com.cn') {
    api = 'https://testtk.lanjiyin.com.cn'
} else {
    api = '/test'
}
//添加请求拦截器
service.interceptors.request.use(function (config) {
    //  *sign=签名，*version=版本号(可选，目前为当前版本)，
    // *from_device=来自安卓还是ios（可选，0：通用 1:Android 2:ios，目前为通用版），
    // *app_id=westernmd_1011
    // 'pharmic_0425'
    // 'pharmic'
    let data = {
        // app_id: localStorage.getItem('app_id'),
        // app_type: localStorage.getItem('app_type'),
        // bundle_id: localStorage.getItem("bundle_id"),
        // user_id: localStorage.getItem('user_id'),
        // big_user_id: localStorage.getItem('big_user_id'),
    }
    if (config.method == "get") {
        if (config.params == undefined) {
            config.params = {}
        }
        for (let key in data) {
            config.params[key] = data[key]
        }
    }
    if (config.method == "post") {
        if (config.data == undefined) {
            config.data = {}
        }
        for (let key in data) {
            config.data[key] = data[key]
        }
        config.data = qs.stringify(config.data)
    }
    config.url = api + config.url;
    return config
}, function (error) {
    return Promise.reject(error)
})
//添加响应拦截器
service.interceptors.response.use(function (response) {

    return response.data
}, function (error) {
    console.log('err' + error)
    return Promise.reject(error)
}
)
export default service


// WEBPACK FOOTER //
// ./src/http/index.js